import React from 'react';
import { useSelector } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';

import t from 'utils/translate';
import {
    selectCompanySettings,
    selectDataLoaded,
    selectOrganizationId,
    selectCoreConfigurationSettings,
} from 'modules/settings/stores/company-settings-slice-handler';
import PriorityLevel from 'modules/shared/components/priority-level';
import LabelWithSiblings from 'modules/shared/components/label-with-siblings';
import CompanyLogo from 'modules/shared/components/company-logo';
import { getLoggedInUser } from 'modules/contacts/stores/contacts-slice-handler';
import { addSnackbar } from 'utils/dialogs-manager';
import SnackbarTypes from 'constants/snackbar-types';
import configIniUtil from 'utils/config-ini-util';

export default function SideBarUserDetails() {
    const companySettings = useSelector(selectCompanySettings);
    const orgId = useSelector(selectOrganizationId);
    const coreConfigurationSettings = useSelector(selectCoreConfigurationSettings);

    let appVersion = configIniUtil.getParam('version');
    appVersion = appVersion.split('.').slice(0,3).join('.');

    const copyLoginLink = () => {
        let link = window.location.href;
        if (link.substring(link.length - 1) !== '/') {
            link += '/';
        }
        link += `index/login/orgId/${orgId}`;
        navigator.clipboard.writeText(link);
        addSnackbar({
            type: SnackbarTypes.SUCCESS,
            title: t('settings_company_id'),
            message: t('copy_login_link_confirmation'),
        });
    };

    return (
        <section className="user-details">
            <div className="info-label">
                <LabelWithSiblings labelContent={t('settings_name')} siblingsMask="L" />
            </div>
            <div className="detail-line">{getLoggedInUser().ComputedUserName}</div>
            <div className="info-label">
                <LabelWithSiblings labelContent={t('settings_phone')} siblingsMask="L" />
            </div>
            <div className="detail-line">+{companySettings.Msisdn}</div>
            {companySettings.Email && (
                <>
                    <div className="info-label">
                        <LabelWithSiblings labelContent={t('settings_email')} siblingsMask="L" />
                    </div>
                    <div className="detail-line">{companySettings.Email}</div>
                </>
            )}
            {companySettings.Position && (
                <>
                    <div className="info-label">
                        <LabelWithSiblings labelContent={t('settings_position')} siblingsMask="L" />
                    </div>
                    <div className="detail-line">{companySettings.Position}</div>
                </>
            )}
            {companySettings.AllowWalkieTalkie && companySettings.AllowPriority && companySettings.Priority > 0 && (
                <>
                    <div className="info-label">
                        <LabelWithSiblings labelContent={t('js_all_supervisor_wt_details')} siblingsMask="L" />
                    </div>
                    <div className="detail-line">
                        {t('js_all_contacts_details_priority_level')}
                        <PriorityLevel priorityLevel={companySettings.Priority} data-test-id="settings-priority" />
                    </div>
                </>
            )}
            <div className="info-label">
                <LabelWithSiblings labelContent={t('settings_company')} siblingsMask="L" />
            </div>
            <div className="detail-line">{companySettings.OrganizationLabel}</div>
            <div className="detail-line">
                <CompanyLogo />
            </div>
            <div className="info-label">
                <LabelWithSiblings labelContent={t('settings_company_id')} siblingsMask="L" />
            </div>
            <div className="detail-line" data-test-id="settings-company-id">
                {orgId}
                {coreConfigurationSettings.openidLoginEnabled && (
                    <>
                        <Tooltip
                            title={t('copy_login_link_tooltip')}
                            placement="right"
                            data-test-id="settings-login-link"
                            arrow
                        >
                            <span className="copy-login-link" onClick={copyLoginLink}>
                                {t('copy_login_link_text')}
                            </span>
                        </Tooltip>
                    </>
                )}
            </div>
            <div className="info-label">
                <LabelWithSiblings labelContent={t('app_version')} siblingsMask="L" />
            </div>
            <div className="detail-line" data-test-id="settings-app-version">
                {appVersion}
            </div>
        </section>
    );
}
